window.addEventListener("load", function () {
  let main_navigation = document.querySelector("#primary-menu");
  let menu_toggle = document.querySelector("#primary-menu-toggle");

  if (menu_toggle && main_navigation) {
    menu_toggle.addEventListener("click", function (e) {
      e.preventDefault();
      main_navigation.classList.toggle("hidden");
    });
  }

  // Pure JS Slider replacement for .first-slider and .mySwiper if needed
  // However, most modern designs use CSS scroll snap for simple sliders

  const initSimpleSlider = (selector) => {
    const sliders = document.querySelectorAll(selector);
    sliders.forEach((slider) => {
      // We convert Swiper structure to a scrollable one if it's not already handled by CSS
      slider.style.display = "flex";
      slider.style.overflowX = "auto";
      slider.style.scrollSnapType = "x mandatory";
      slider.style.webkitOverflowScrolling = "touch";
      slider.style.scrollbarWidth = "none"; // Firefox
      slider.style.msOverflowStyle = "none"; // IE/Edge

      const wrapper = slider.querySelector(".swiper-wrapper");
      if (wrapper) {
        wrapper.style.display = "flex";
        wrapper.style.width = "max-content";
      }

      const slides = slider.querySelectorAll(".swiper-slide");
      slides.forEach((slide) => {
        slide.style.scrollSnapAlign = "start";
        slide.style.flexShrink = "0";
      });
    });
  };

  // If there are other sliders not yet converted in template parts:
  // initSimpleSlider('.first-slider');
  // initSimpleSlider('.mySwiper');
});
